module.exports = __webpack_public_path__ + "0ed4badfc47f460d322aa2a5375fefb6.png";